import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { WhoIsThisForSection } from '../components/WhoIsThisForSection';
import { SalesLetter } from '../components/SalesLetter';
import { FormatsSection } from '../components/FormatsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ScrollProgress';
import { CountdownTimer } from '../components/CountdownTimer';
import { StickyCartButton } from '../components/StickyCartButton';
import { FloatingContactButton } from '../components/FloatingContactButton';
import { AnimatedSection } from '../components/AnimatedSection';
import { LiveNotifications } from '../components/LiveNotifications';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-335">
      <ScrollProgress data-id="element-336" />
      <CountdownTimer data-id="element-337" />
      <StickyCartButton data-id="element-338" />
      <FloatingContactButton data-id="element-339" />
      <LiveNotifications data-id="element-340" />

      <HeroSection data-id="element-341" />

      <AnimatedSection animation="fade-in" data-id="element-342">
        <WhoIsThisForSection data-id="element-343" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-344">
        <SalesLetter data-id="element-345" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-346">
        <FormatsSection data-id="element-347" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-348">
        <FAQSection data-id="element-349" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-350">
        <GuaranteeSection data-id="element-351" />
      </AnimatedSection>

      <Footer data-id="element-352" />
    </div>;
}